<!-- @format -->

<template>
  <div id="participants">
    <div class="content-wrapper">
      <portal to="action-buttons">
        <ul class="navbar-nav ml-md-auto">
          <li class="nav-item">
            <el-dropdown stlye="height: 32px;" v-if="checkList.length > 0">
              <el-button size="small" type="success" round>
                <i style="font-size: 12px;" class="el-icon-position"></i>
                {{ $t("participantManagament.attendeeList.participant.choose", [checkList.length]) }}
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="bulkCardPrintDialog = true">
                  <i class="fas fa-id-card"></i>
                  {{ $t("participantManagament.attendeeList.participant.batchPrint") }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="sendFilteredVoucher">
                  <i class="fas fa-paper-plane"></i>
                  {{ $t("participantManagament.attendeeList.participant.sendVoucher") }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="sendFilteredCertificate">
                  <i class="fas fa-paper-plane"></i>
                  {{ $t("participantManagament.attendeeList.participant.sendCertificate") }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="checkList = []">
                  <i class="fas fa-times"></i>
                  {{ $t("participantManagament.attendeeList.participant.clearSelected") }}
                </el-dropdown-item>
                <el-dropdown-item v-if="false" @click.native="bulkDelete">
                  <i class="fas fa-trash"></i>
                  {{ $t("participantManagament.attendeeList.participant.deleteSelected") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- <li class="nav-item">
            <el-button round type="primary" size="small" @click="sendParticipantVoucher">Send voucher</el-button>
          </li> -->
          <li class="nav-item">
            <el-dropdown stlye="height: 32px;" :hide-on-click="false">
              <el-button size="small" type="warning" round>
                <i style="font-size: 12px;" class="fas fa-question"></i>
                {{ $t("participantManagament.attendeeList.participant.questions") }}
              </el-button>
              <el-dropdown-menu slot="dropdown" class="predefined-dropdown">
                <el-dropdown-item class="px-1" v-for="(predQuestion, predIndex) in predefinedQuestions" :key="'pred-question-' + predIndex" @click.native="changeSelectedPredefined(predQuestion)">
                  <span class="w-100 d-flex flex-row justify-content-between" style="gap:10px" v-if="getEnums != null">
                    {{ getEnumsDisplay("RegistrationInputType", predQuestion) }}
                    <el-checkbox :checked="selectedPredefined.some(x => x == predQuestion)" :key="selectedPredefined.some(x => x == predQuestion)" disabled></el-checkbox>
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- <li class="nav-item">
						<el-dropdown stlye="height: 32px;">
							<el-button size="small" type="warning" round>
								<i style="font-size: 12px;" class="fas fa-envelope"></i>
								{{ 'Gönderim' }}
							</el-button>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="sendParticipantVoucher">
									<i class="fas fa-paper-plane"></i>
									{{ 'Voucher gönder' }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</li> -->
          <li class="nav-item">
            <el-dropdown stlye="height: 32px;">
              <el-button size="small" type="warning" round>
                <i style="font-size: 12px;" class="fas fa-exchange-alt"></i>
                {{ this.$t("event.components.participants.navbar.transfer.title") }}
              </el-button>
              <el-dropdown-menu slot="dropdown" class="predefined-dropdown">
                <el-dropdown-item @click.native="importExcell(1)">
                  <i class="fas fa-upload"></i>
                  {{ this.$t("event.components.participants.navbar.transfer.import") }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="openExcellDialog">
                  <i class="fas fa-download"></i>
                  {{ this.$t("event.components.participants.navbar.transfer.export") }}
                </el-dropdown-item>
                <el-dropdown-item v-for="(item, index) in $store.state.registerform.registerFormList" @click.native="downloadTemplate(item.id)" :key="index" :divided="index == 0 ? true : false">
                  <i class="fas fa-file-excel"></i>
                  {{ $t("participantManagament.attendeeList.participant.export", [item.title]) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li class="nav-item">
            <el-tooltip effect="dark" :content="$t('buttonGeneral.searchFilter')" placement="top">
              <el-button circle :icon="loading == 'filterModalOpen' ? 'fas fa-spinner fa-spin' : 'fas fa-search'" :type="isFiltered ? 'success' : ''" size="small" @click="openFilterModal"></el-button>
            </el-tooltip>
          </li>
          <li class="nav-item">
            <el-button
              icon="fas fa-plus"
              type="primary"
              size="small"
              round
              @click="
                participantAddId = null;
                participantAddModal = true;
              "
            >
              {{ $t("participantManagament.attendeeList.participant.addAttendee") }}
            </el-button>
          </li>
        </ul>
      </portal>

      <div class="content animated fadeIn">
        <transition name="slide-fade">
          <div v-if="isFilterEnabled" class="card card-collapsed filter-card">
            <div class="card-header">
              <div class="card-title-container">
                <h5 class="card-title">{{ this.$t("event.filter.title") }}</h5>
                <span>{{ $t("participantManagament.attendeeList.participant.filterMsg") }}</span>
              </div>
              <div class="header-elements">
                <el-button-group>
                  <el-button @click="resetFilter" icon="el-icon-refresh-right" size="mini" round>{{ $t("event.buttons.reset") }}</el-button>
                  <el-button type="warning" icon="el-icon-close" size="mini" @click="isFilterEnabled = false" round></el-button>
                </el-button-group>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="form-group col-md-4">
                  <label>{{ this.$t("event.filter.search") }}</label>
                  <el-input clearable v-model="filter.searchTerm" placeholder="..."></el-input>
                </div>

                <div class="form-group col-md-4">
                  <label>{{ this.$t("event.filter.group") }}</label>
                  <el-select v-model="filter.groupIDs" :placeholder="$t('event.textbox.select')" clearable multiple>
                    <el-option v-for="item in $store.state.groups.items" :key="item.id" :label="item.title" :value="item.id">
                      <template>
                        <i class="fas fa-square mr-2" :style="'color:' + item.color"></i>
                        <span>{{ item.title }}</span>
                      </template>
                    </el-option>
                  </el-select>
                </div>

                <div class="form-group col-md-4">
                  <label>{{ this.$t("event.filter.tag") }}</label>

                  <el-select multiple v-model="filter.tagIDs" :placeholder="$t('event.textbox.selectTag')">
                    <el-option v-for="item in $store.state.tags.items" :key="item.id" :label="item.title" :value="item.id">
                      <template>
                        <i class="fas fa-circle mr-2" :style="'color:' + item.color"></i>
                        <span>{{ item.title }}</span>
                      </template>
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!-- Collapse -->
              <el-collapse v-model="activeNames" v-if="$store.state.participants.detailedFilter">
                <el-collapse-item name="1" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.createDateInfo") }}
                  </template>
                  <div class="row">
                    <div class="form-group col-md-12">
                      <label for>{{ this.$t("event.filter.dates") }}</label>
                      <el-date-picker v-model="filter.createDateRange" type="datetimerange" :start-placeholder="$t('startDate')" :end-placeholder="$t('endDate')" :format="'dd MMMM yyyy HH:mm:ss'" :value-format="'yyyy-MM-ddTHH:mm:ss.000Z'" :default-time="['00:00:00', '23:59:00']"></el-date-picker>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="2" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.paymentInfo") }}
                  </template>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>{{ this.$t("event.filter.registrationForm") }}</label>
                      <el-select
                        clearable
                        v-model="filter.registrationFormId"
                        placeholder="..."
                        @clear="
                          filter.registrationFormId = null;
                          filter.packetIds = [];
                          filter.additionalServiceIds = [];
                          filter.additionalServiceStatus = null;
                          filter.additionalProductIds = [];
                          filter.additionalProductStatus = null;
                        "
                      >
                        <el-option v-for="form in registerFormList" :key="form.id" :label="form.title" :value="form.id"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6" v-if="filter.registrationFormId == null"></div>
                    <div class="form-group col-md-6" v-else>
                      <label>{{ this.$t("event.filter.registrationPackets") }}</label>
                      <el-select clearable multiple v-model="filter.packetIds" placeholder="..." v-if="registerFormList.find(x => x.id == filter.registrationFormId)">
                        <el-option v-for="(packet, packetIndex) in registerFormList.find(x => x.id == filter.registrationFormId).packets" :key="packet.packetId + '-packet-id-index' + packetIndex" :label="packet.title" :value="packet.packetId"></el-option>
                      </el-select>
                    </div>
                    <!-- <div class="form-group col-md-6" v-if="filter.registrationFormId != null">
                      <label>Ek Hizmetler</label>
                      <el-select v-model="filter.additionalServiceIds" multiple @clear="filter.additionalServiceIds = null">
                        <el-option v-for="(service, serviceIndex) in registerFormList.find(x => x.id == filter.registrationFormId).additionalServices" :key="service.id + '-service-id-index-' + serviceIndex" :label="service.title" :value="service.id"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6" v-if="filter.registrationFormId != null">
                      <label>Ek Hizmet Durumu</label>
                      <el-select v-model="filter.additionalServiceStatus" @clear="filter.additionalServiceStatus = null">
                        <el-option v-for="(option, index) in getEnums.find(x => x.title == 'ParticipantAdditionalServiceStatus').enums" :key="option.displayName + '-option-participant-additionalservicestatus-' + index" :label="option.displayName" :value="option.key"></el-option>
                      </el-select>
                    </div> -->
                    <!-- <div class="form-group col-md-6" v-if="filter.registrationFormId != null">
                      <label>Ek Ürünler</label>
                      <el-select v-model="filter.additionalProductIds" multiple @clear="filter.additionalProductIds = []">
                        <el-option v-for="(product, productIndex) in products" :key="product.id + '-product-id-index-' + productIndex" :label="product.title" :value="product.id"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6" v-if="filter.registrationFormId != null">
                      <label>Ek Ürün Durumu</label>
                      <el-select v-model="filter.additionalProductStatus" @clear="filter.additionalProductStatus = null">
                        <el-option v-for="(option, index) in getEnums.find(x => x.title == 'AdditionalProductRegistrationStatus').enums" :key="option.displayName + '-option-participant-additionalproductstatus-' + index" :label="option.displayName" :value="option.key"></el-option>
                      </el-select>
                    </div> -->

                    <div class="form-group col-md-2">
                      <label>{{ this.$t("event.filter.paymentID") }}</label>
                      <el-input clearable v-model="filter.paymentID" placeholder="..."></el-input>
                    </div>

                    <div class="form-group col-md-2">
                      <label>{{ this.$t("event.filter.couponCode") }}</label>
                      <el-input clearable v-model="filter.couponCode" placeholder="..."></el-input>
                    </div>

                    <div class="form-group col-md-4">
                      <label>{{ this.$t("event.filter.paymentStatus") }}</label>
                      <el-select v-model="filter.paymentStatus" :placeholder="$t('event.textbox.select')" clearable @clear="filter.paymentStatus = null">
                        <el-option v-for="item in $enums.paymentStatus" :key="item.value" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </div>

                    <div class="form-group col-md-4">
                      <label>{{ this.$t("event.filter.paymentType") }}</label>
                      <el-select v-model="filter.paymentType" :placeholder="$t('event.textbox.select')" clearable @clear="filter.paymentType = null">
                        <el-option v-for="item in $enums.paymentType" :key="item.value" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </div>

                    <div class="form-group col-md-4">
                      <label>{{ this.$t("event.filter.dayRestriction") }}</label>
                      <el-select v-model="filter.dayRestriction" clearable @clear="filter.dayRestriction = null">
                        <el-option v-for="(day, dayIndex) in eventDateList" :key="dayIndex" :label="$moment(new Date(day).toISOString()).format('DD MMMM YYYY, dddd')" :value="new Date(day).toISOString()"></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="3" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.voucherInfo") }}
                  </template>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label for>{{ this.$t("event.filter.automatedMessageId") }}</label>
                      <el-select
                        :placeholder="$t('event.textbox.select')"
                        filterable
                        v-model="filter.automatedMessageId"
                        @clear="
                          filter.automatedMessageId = null;
                          filter.automatedMessageLogStatus = null;
                          filter.automatedMessageType = null;
                        "
                        clearable
                      >
                        <el-option v-for="message in $store.state.automatedmessages.items" :key="message.id" :value="message.id" :label="message.title"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for>{{ this.$t("event.filter.automatedMessageStatus") }}</label>
                      <el-select v-model="filter.automatedMessageLogStatus" :disabled="filter.automatedMessageId == null" :placeholder="$t('event.textbox.select')" clearable @clear="filter.automatedMessageLogStatus = null">
                        <el-option v-for="(option, index) in getEnums.find(x => x.title == 'AutomatedMessageLogStatus').enums" :label="option.displayName" :value="option.key" :key="index"></el-option>
                      </el-select>
                    </div>
                    <div class="form-group col-md-6">
                      <label for>{{ this.$t("event.filter.automatedMessageType") }}</label>
                      <el-select v-model="filter.automatedMessageType" :disabled="filter.automatedMessageId == null" :placeholder="$t('event.textbox.select')" clearable @clear="filter.automatedMessageType = null">
                        <el-option v-for="(option, index) in getEnums.find(x => x.title == 'AutomatedMessageType').enums.filter(x => x.key == 0 || x.key == 24)" :label="option.displayName" :value="option.key" :key="index"></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="4" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.activationInfo") }}
                  </template>

                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for>{{ this.$t("event.filter.activationStatus") }}</label>
                      <el-select v-model="filter.activationStatus" :placeholder="$t('event.textbox.select')" clearable @clear="filter.activationStatus = null">
                        <el-option v-for="item in $enums.activationStatus" :key="item.value" :label="item.title" :value="item.value"></el-option>
                      </el-select>
                    </div>

                    <div class="form-group col-md-4">
                      <label for>{{ this.$t("event.filter.activationCode") }}</label>
                      <el-input clearable v-model="filter.activationCode" placeholder="...."></el-input>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="5" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("checkpoint_") }}
                  </template>

                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for>
                        {{ this.$t("event.table.checkpoint") }}
                      </label>
                      <el-select clearable v-model="filter.venueID" :placeholder="$t('event.textbox.select')" @clear="filter.venueID = null">
                        <el-option v-for="item in $store.state.venues.items" :key="item.id" :label="item.title" :value="item.id"></el-option>
                      </el-select>
                    </div>

                    <div class="form-group col-md-8">
                      <label for>{{ this.$t("event.filter.dates") }}</label>
                      <el-date-picker v-model="filter.venueDateRange" type="datetimerange" :format="'dd MMMM yyyy HH:mm:ss'" :value-format="'yyyy-MM-ddTHH:mm:ss.000Z'" :start-placeholder="$t('startDate')" :end-placeholder="$t('endDate')" :default-time="['00:00:00', '23:59:00']"></el-date-picker>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="6" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.checkinInfo") }}
                  </template>

                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for>{{ this.$t("event.filter.checkinStatus") }}</label>
                      <div class="gorm-gorup">
                        <el-radio v-model="filter.checkIn" :label="null">{{ this.$t("event.filter.all") }}</el-radio>
                        <el-radio v-model="filter.checkIn" :label="true">{{ this.$t("event.filter.checkedIn") }}</el-radio>
                        <el-radio v-model="filter.checkIn" :label="false">{{ this.$t("event.filter.unchecked") }}</el-radio>
                      </div>
                    </div>

                    <div class="form-group col-md-8">
                      <label for>{{ this.$t("event.filter.dates") }}</label>
                      <el-date-picker v-model="filter.checkInDateRange" type="datetimerange" :format="'dd MMMM yyyy HH:mm:ss'" :value-format="'yyyy-MM-ddTHH:mm:ss.000Z'" :start-placeholder="$t('startDate')" :end-placeholder="$t('endDate')" :default-time="['00:00:00', '23:59:00']"></el-date-picker>
                    </div>
                  </div>
                </el-collapse-item>
                <el-collapse-item name="7" v-if="$store.state.participants.detailedFilter">
                  <template slot="title">
                    {{ this.$t("event.filter.cardPrintInfo") }}
                  </template>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for>{{ this.$t("event.filter.cardPrintStatus") }}</label>
                      <div class="gorm-gorup">
                        <el-radio v-model="filter.isCardPrinted" :label="null">{{ this.$t("event.filter.all") }}</el-radio>
                        <el-radio v-model="filter.isCardPrinted" :label="true">{{ this.$t("event.filter.cardPrinted") }}</el-radio>
                        <el-radio v-model="filter.isCardPrinted" :label="false">{{ this.$t("event.filter.cardNonPrinted") }}</el-radio>
                      </div>
                    </div>

                    <div class="form-group col-md-8">
                      <label for>{{ this.$t("event.filter.dates") }}</label>
                      <el-date-picker v-model="filter.cardDateRange" type="datetimerange" :start-placeholder="$t('startDate')" :end-placeholder="$t('endDate')" :format="'dd MMMM yyyy HH:mm:ss'" :value-format="'yyyy-MM-ddTHH:mm:ss.000Z'" :default-time="['00:00:00', '23:59:00']"></el-date-picker>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <!-- Collapse Son -->
              <div style="display: flex; justify-content: flex-end">
                <a href="javascript:;" v-if="$store.state.participants.detailedFilter" @click="$store.state.participants.detailedFilter = false">{{ this.$t("event.buttons.closeDetailed") }}</a>
                <a href="javascript:;" v-if="!$store.state.participants.detailedFilter" @click="$store.state.participants.detailedFilter = true">{{ this.$t("event.buttons.openDetailed") }}</a>
              </div>
            </div>
          </div>
        </transition>

        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ this.$t("event.menu.participants.title") }}</h5>
              <span v-if="filter.total > 0" v-html="$t('totalContent', [filter.total])"></span>
            </div>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :icon="loading == 'loadingList' ? 'el-icon-loading' : 'fas fa-redo-alt'" size="mini" @click="refreshList" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>
          <!-- <span>{{ $store.state.participants.items.length }}</span> -->
          <!-- <div class="card-body" v-if="filter.total > 0 && !loading"> -->
          <div class="card-body" v-if="$store.state.participants.items.length > 0 && !loading">
            <div class="custom-grid-table-header participant-table-header" :style="gridStyle" :key="selectedPredefined.length + '-grid-header'">
              <div>
                <el-tooltip class="item d-flex align-items-center justify-content-center" effect="dark" :content="$t('event.buttons.selectAll')" placement="top-start">
                  <div>
                    <el-button size="mini" :type="checkList.length > 0 ? 'primary' : 'default'" @click="allSelectList" circle icon="el-icon-check"></el-button>
                  </div>
                  <!-- <el-checkbox class="mb-0" :value="checkList.length == $store.state.participants.items.length"  :key="checkListKey" @change="allSelectList"></el-checkbox> -->
                </el-tooltip>
              </div>
              <div>{{ $t("participantManagament.attendeeList.participant.AttendeeNumber") }}</div>
              <div>{{ $t("participantManagament.attendeeList.participant.nameSurname") }}</div>
              <div v-for="(prequestion, prequestionIndex) in selectedPredefined" :key="'prequestion-' + prequestionIndex + '-selected'">
                {{ getEnumsDisplay("RegistrationInputType", prequestion) }}
              </div>
              <div>{{ $t("participantManagament.attendeeList.participant.registrationDate") }}</div>
              <div></div>
            </div>
            <div class="participant-table-items" v-if="tagList.length > 0">
              <div class="item" v-for="item in $store.state.participants.items" :key="item.id + selectedPredefined.length + '-grid-list-item'" :style="gridStyle">
                <div class="cursor-pointer d-flex align-items-center justify-content-center w-100 h-100" @click.stop="changeList(item.id)">
                  <el-checkbox :key="checkListKey" :checked="checkList.some(x => x == item.id)" @change="changeList(item.id)"></el-checkbox>
                </div>
                <div class="participant-no cursor-pointer" @click.stop="changeList(item.id)">{{ item.participantNO }}</div>
                <div class="participant-header cursor-pointer" @click="openParticipantInfoDialog(item.id)">
                  <div class="participant-title">{{ item.fullName }}</div>
                  <el-tooltip placement="top" v-if="item.subTagIds.length > 0">
                    <div slot="content" style="gap:10px;max-width:max-content" class="d-flex flex-row flex-wrap">
                      <el-tag :closable="false" v-for="(tagItem, tagItemIndex) in item.subTagIds" :key="tagItem + 'sub-tag-item-' + tagItemIndex">
                        <span>{{ getTag(tagItem).title }}</span>
                      </el-tag>
                    </div>
                    <div class="participant-tag d-flex align-items-center justify-content-start" v-if="getTag(item.tagID) != null">
                      <div class="tag-color-pick" :style="{ 'background-color': getTag(item.tagID).color }"></div>
                      <span>
                        {{ getTag(item.tagID).title }}
                        <b>(+{{ item.subTagIds.length }})</b>
                      </span>
                    </div>
                  </el-tooltip>
                  <template v-else>
                    <div class="participant-tag d-flex align-items-center justify-content-start" v-if="getTag(item.tagID) != null">
                      <div class="tag-color-pick" :style="{ 'background-color': getTag(item.tagID).color }"></div>
                      <span>{{ getTag(item.tagID).title }}</span>
                    </div>
                  </template>
                </div>
                <div v-for="(predItem, predItemIndex) in selectedPredefined" :key="predItemIndex + '-predItemType'">
                  {{ item.registrationInputs.some(x => x.type == predItem) ? item.registrationInputs.find(x => x.type == predItem).answer : "" }}
                </div>
                <div>
                  {{ $moment(item.createDate).utc().format(dateFormatEvent($store.state.event.event.dateFormat)) + " " + $moment(item.createDate).format(timeFormatEvent($store.state.event.event.timeFormat)) }}
                </div>
                <div class="d-flex justify-content-end align-items-center" style="gap:0.3rem">
                  <el-tooltip effect="dark" :content="$t('buttonGeneral.edit')" placement="top">
                    <el-button
                      size="mini"
                      circle
                      icon="fas fa-pen"
                      type="primary"
                      @click.stop="
                        participantAddId = item.id;
                        participantAddModal = true;
                      "
                    ></el-button>
                  </el-tooltip>

                  <el-tooltip effect="dark" :content="$t('buttonGeneral.delete')" placement="top">
                    <el-popconfirm @confirm="deleteItem(item.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                      <el-button size="mini" slot="reference" :loading="loading == 'deleteItem-' + item.id" @click.stop="" circle icon="fas fa-trash" type="danger" class="m-0"></el-button>
                    </el-popconfirm>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData
              class="w-100"
              key="create-loading"
              :source="'holacon-attendee-lottie'"
              :title="$t('event.menu.participants.title')"
              @btnAdd="
                participantAddId = null;
                participantAddModal = true;
              "
              @btnRefresh="refreshList()"
              :buttonAdd="true"
              :buttonRefresh="true"
              :loading="loading"
            />
          </div>

          <div class="card-footer d-flex justify-content-center">
            <div class="participants-footer" v-if="filter.total > 0">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50, 100]" :page-size="filter.take" layout="sizes,prev, pager, next" :total="filter.total"></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="bulkCardPrintDialog" :title="$t('participantManagament.registrationSearch.detailsParticipant.cardPrint')" center class="medium" modal-append-to-body destroy-on-close>
      <BulkCardPrint :participantIds="checkList" @closeDialog="bulkCardPrintDialog = false" v-if="bulkCardPrintDialog" />
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :visible.sync="participantAddModal" :title="participantAddId == null ? $t('participantManagament.attendeeList.participant.addAttendee') : $t('participantManagament.attendeeList.participant.editAttendee')" class="large" center modal-append-to-body destroy-on-close>
      <AddUpdateParticipant v-if="participantAddModal" :id="participantAddId" @closeDialog="participantAddModal = false" @refresh="$store.dispatch('getParticipants')" @itemCreated="participantItemCreated" />
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :visible.sync="participantDetailModal" :title="$t('participantManagament.attendeeList.participant.detailsAttendee')" class="large" center :destroy-on-close="true">
      <div id="participant-details-modal" class="custom-modal" v-if="participantDetailModal">
        <div class="modal-body">
          <ParticipantDetails :id="participantDetailId" v-if="participantDetailModal" @closeDialog="participantDetailModal = false" @refreshList="$store.dispatch('getParticipants')" @deletedMe="participantDetailModal = false" />
        </div>
        <div class="modal-footer">
          <div class="left-buttons">
            <el-button @click="participantDetailModal = false">{{ $t("participantManagament.attendeeList.participant.close") }}</el-button>
          </div>
          <div class="right-buttons"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AddUpdateParticipant from "../../components/participants/AddUpdateParticipant.vue";
import ParticipantDetails from "../../components/participants/ParticipantDetails.vue";
import BulkCardPrint from "../../components/participants/BulkCardPrint.vue";
// import ParticipantAddOrUpdate from '../../components/ParticipantAddOrUpdate';
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import moment from "moment/min/moment-with-locales";
import $ from "jquery";
export default {
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.participants")
    };
  },
  components: { AddUpdateParticipant, ParticipantDetails, PageCountInfo, BulkCardPrint },
  name: "Participants",
  data() {
    return {
      bulkCardPrintDialog: false,
      eventDateList: [],
      predefinedQuestions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34],
      selectedPredefined: [],
      checkListKey: +new Date(),
      participantDetailId: null,
      participantDetailModal: false,
      loading: null,
      participantAddId: null,
      participantAddModal: false,
      activeNames: ["1"],
      select_orderId: [],
      showCheckin: false,
      showRegDate: true,
      certificateValidationErrors: [],
      sendAllModal: false,
      selectedsSendModal: false,
      certificateID: null,
      sendFilterValidationErrors: [],
      filterSendModal: false,
      sendCertificateLoading: false,
      certificates: [],
      bulkErrorModal: false,
      bulkDeleteValidationErrors: [],
      checkList: [],
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      select_order_number: null,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "speaker",
      widgetUrl: "https://cdn.holacon.com/widgets/event-speakers.html?applicationID=5e2b3b73286bd618b47d1e6e&amp;eventID=5e30227b83089521b86ef7bf",
      excelTemplateUrl: this.$excelTemplateUrl + "sample/SpeakerExcel/SpeakerImportSample.xlsx"
    };
  },
  methods: {
    allSelectList() {
      if (this.$store.state.participants.items.length > 0) {
        this.$store.state.participants.items.forEach(x => {
          if (!this.checkList.some(y => y == x.id)) {
            this.checkList.push(x.id);
          }
        });
        this.checkListKey += 1;
      }
    },
    async openFilterModal() {
      this.loading = "filterModalOpen";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var dateArray = new Array();

        var a = new Date(this.$store.state.event.event.startDate);
        var b = new Date(this.$store.state.event.event.endDate);

        var currentDate = new Date(a.getFullYear(), a.getMonth(), a.getDate());
        while (currentDate <= b) {
          dateArray.push(new Date(currentDate));
          currentDate = currentDate.addDays(1);
        }
        dateArray.map(x => x.setHours(3));
        this.eventDateList = dateArray;
        await this.$store.dispatch("getRegisterForm");
        await this.$store.dispatch("getProducts");
        this.isFilterEnabled = !this.isFilterEnabled;
        this.loading = false;
      }, 500);
    },
    changeSelectedPredefined(type) {
      var fIndex = this.selectedPredefined.findIndex(x => x == type);
      if (fIndex != -1) {
        this.selectedPredefined.splice(fIndex, 1);
      } else {
        this.selectedPredefined.push(type);
      }
    },
    changeList(id) {
      var fIndex = this.checkList.findIndex(x => x == id);
      if (fIndex != -1) {
        this.checkList.splice(fIndex, 1);
      } else {
        this.checkList.push(id);
      }
    },
    bulkDelete() {
      //
    },
    sendFilteredVoucher() {
      this.sendVoucher(this.checkList, null);
    },
    sendFilteredCertificate() {
      this.sendCertificate(this.checkList, null);
    },
    sendParticipantVoucher() {
      this.sendVoucher([], JSON.stringify(this.filter));
    },
    changetab() {
      const demoClasses = document.querySelectorAll(".delCon__select");
      demoClasses.forEach(button => {
        button.setAttribute("tabindex", "0");
      });
      return true;
    },
    openExcellDialog() {
      this.exportXlsx(1, null, JSON.stringify(this.filter));
    },
    participantItemCreated(item) {
      this.participantAddModal = false;

      this.participantDetailId = item.id;
      this.participantDetailModal = true;
    },
    openParticipantInfoDialog(id) {
      this.participantDetailId = id;
      this.participantDetailModal = true;
    },
    getTag(id) {
      var tag = this.tagList.find(x => x.id == id);
      return tag;
    },
    refreshList() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getParticipants");
        await this.$store.dispatch("getTags");
        this.loading = false;
      }, 500);
    },
    getLocale(locale) {
      this.$i18n.locale = locale;
      moment.locale(locale);
    },

    importSuccess() {
      this.$store.dispatch("getParticipants");
    },

    exportExcel() {
      this.$confirm(this.$t("message.export"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("participant/export", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    exportSampleExcel() {
      this.$confirm(this.$t("message.sureCreate"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning"
      }).then(() => {
        axios.post("participant/generatesample", { id: null }).then(res => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    excelProgress(event) {
      this.excelPercent = event.percent;
    },
    itemUpdated(item) {
      this.$store.dispatch("getParticipants");
    },
    itemAdded(item) {
      this.$store.dispatch("getParticipants");
    },
    handleSizeChange(take) {
      // this.filter.take = take;
      this.$store.commit("setParticipantTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setParticipantPage", page);

      this.filter.page = page;
    },
    // handleSizeChange(take) {
    // },
    // handleCurrentChange(page) {
    // },
    async deleteItem(id) {
      this.loading = "deleteItem-" + id;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("deleteParticipant", id);
        this.loading = false;
      }, 500);
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleParticipant", { index, value });
    },
    getRowKeys(item) {
      return item.id;
    },
    updateChecked(item) {
      var index = this.$store.state.participants.selectedItems.findIndex(x => x.id == item.id);
      if (index != -1) {
        this.$store.state.participants.selectedItems.splice(index, 1);
      } else {
        this.$store.state.participants.selectedItems.push(item);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isBlocked) {
        return "row-passive";
      } else if (row.proxtParticipant != null) {
        return "row-proxy";
      }

      return "row-active";
    },
    async downloadTemplate(id) {
      this.$message.info(this.$t("generic.generatingPleaseWait"));
      var res = await this.$store.dispatch("exportXlscx", { type: 11, itemId: id, queryJson: null });
      if (!res.data.alert.hasError) {
        window.open(res.data.data.url, "_blank");
      }
    },
    removeElement(array, elem) {
      var index = array.findIndex(k => k == elem);
      while (index > -1) {
        array.splice(index, 1);
        index = array.indexOf(elem) - 1;
      }
    },
    clearAllSelection() {
      console.log("asd");
      this.$nextTick(() => {
        this.$store.state.participants.selectedItems = [];
      });
      this.$nextTick(() => {
        this.$store.state.participants.items.forEach(x => (x.checked = false));
      });
    },
    resetFilter() {
      this.$store.state.participants.filter = {
        ...this.$store.state.participants.filter,
        searchTerm: null,
        checkIn: null,
        isCardPrinted: null,
        voucherSendStatus: null,
        voucherTaskStatus: null,
        voucherType: null,
        activationStatus: null,
        minimumCheckInDate: null,
        maximumCheckInDate: null,
        paymentStatus: null,
        promotionIDs: null,
        tagIDs: null,
        dayRestriction: null,
        automatedMessageId: null,
        automatedMessageLogStatus: null,
        automatedMessageType: null,
        groupIDs: null,
        activationCode: null,
        paymentType: null,
        subEventIDs: null,
        couponCode: null,
        paymentID: null,
        minCardPrintDate: null,
        maxCardPrintDate: null,
        minCheckInDate: null,
        maxCheckInDate: null,
        checkInDateRange: null,
        cardDateRange: null,
        venueMinDate: null,
        venueMaxDate: null,
        venueDateRange: null,
        venueID: null,
        createDateRange: null,
        createDateMinDate: null,
        createDateMaxDate: null
      };
    }
  },
  async mounted() {
    this.changetab();
    // var rInputs = localStorage.getItem("rInputs" + this.$store.state.event.event.id);
    // if (rInputs != null) {
    //   this.$store.state.participants.selectedRegistrationInputs = JSON.parse(rInputs);
    // }

    if (this.$route.params.activationStatus) {
      this.$store.state.participants.filter.activationStatus = this.$route.params.activationStatus;
    } else {
      this.$store.state.participants.filter.activationStatus = null;
    }

    var lang = localStorage.getItem("lang");
    this.getLocale(lang);
    this.selectedPredefined = [1, 2, 3];
  },
  async created() {
    this.loading = "loadingScreen";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await Promise.all([this.$store.dispatch("getTags"), this.$store.dispatch("getParticipants"), this.$store.dispatch("getVenues"), this.$store.dispatch("getRegisterForm"), this.$store.dispatch("getAutomatedMessagesList")]);
      this.$store.state.participants.filter.take = 20;
      this.loading = false;
    }, 500);
  },

  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
    registerFormList() {
      return this.$store.getters.getRegisterFormList;
    },
    gridStyle() {
      return {
        gridTemplateColumns: `36px 120px 1fr repeat(${this.selectedPredefined.length}, 1fr) 150px 120px`
      };
    },
    products() {
      return this.$store.getters.getProducts;
    },
    filter() {
      return this.$store.getters.getParticipantFilter;
    },
    tagList() {
      return this.$store.getters.getTagsList;
    },
    skip() {
      return (this.$store.state.participants.filter.page - 1) * this.$store.state.participants.filter.take;
    },
    take() {
      return this.skip + this.$store.state.participants.items.length;
    },
    isFiltered() {
      if (
        (this.$store.state.participants.filter.dayRestriction != null && this.$store.state.participants.filter.dayRestriction != "") ||
        (this.$store.state.participants.filter.searchTerm != null && this.$store.state.participants.filter.searchTerm != "") ||
        (this.$store.state.participants.filter.checkIn != null && this.$store.state.participants.filter.checkIn != "") ||
        (this.$store.state.participants.filter.isCardPrinted != null && this.$store.state.participants.filter.isCardPrinted != "") ||
        (this.$store.state.participants.filter.voucherSendStatus != null && this.$store.state.participants.filter.voucherSendStatus != "") ||
        (this.$store.state.participants.filter.voucherTaskStatus != null && this.$store.state.participants.filter.voucherTaskStatus != "") ||
        (this.$store.state.participants.filter.voucherType != null && this.$store.state.participants.filter.voucherType != "") ||
        (this.$store.state.participants.filter.activationStatus != null && this.$store.state.participants.filter.activationStatus != "") ||
        (this.$store.state.participants.filter.minimumCheckInDate != null && this.$store.state.participants.filter.minimumCheckInDate != "") ||
        (this.$store.state.participants.filter.maximumCheckInDate != null && this.$store.state.participants.filter.maximumCheckInDate != "") ||
        (this.$store.state.participants.filter.automatedMessageId != null && this.$store.state.participants.filter.automatedMessageId != "") ||
        (this.$store.state.participants.filter.automatedMessageLogStatus != null && this.$store.state.participants.filter.automatedMessageLogStatus != "") ||
        (this.$store.state.participants.filter.automatedMessageType != null && this.$store.state.participants.filter.automatedMessageType != "") ||
        (this.$store.state.participants.filter.paymentStatus != null && this.$store.state.participants.filter.paymentStatus != "") ||
        (this.$store.state.participants.filter.promotionIDs != null && this.$store.state.participants.filter.promotionIDs != "") ||
        (this.$store.state.participants.filter.tagIDs != null && this.$store.state.participants.filter.tagIDs != "") ||
        (this.$store.state.participants.filter.groupIDs != null && this.$store.state.participants.filter.groupIDs != "") ||
        (this.$store.state.participants.filter.activationCode != null && this.$store.state.participants.filter.activationCode != "") ||
        (this.$store.state.participants.filter.paymentType != null && this.$store.state.participants.filter.paymentType != "") ||
        (this.$store.state.participants.filter.subEventIDs != null && this.$store.state.participants.filter.subEventIDs != "") ||
        (this.$store.state.participants.filter.couponCode != null && this.$store.state.participants.filter.couponCode != "") ||
        (this.$store.state.participants.filter.paymentID != null && this.$store.state.participants.filter.paymentID != "") ||
        (this.$store.state.participants.filter.minCardPrintDate != null && this.$store.state.participants.filter.minCardPrintDate != "") ||
        (this.$store.state.participants.filter.maxCardPrintDate != null && this.$store.state.participants.filter.maxCardPrintDate != "") ||
        (this.$store.state.participants.filter.minCheckInDate != null && this.$store.state.participants.filter.minCheckInDate != "") ||
        (this.$store.state.participants.filter.maxCheckInDate != null && this.$store.state.participants.filter.maxCheckInDate != "") ||
        (this.$store.state.participants.filter.checkInDateRange != null && this.$store.state.participants.filter.checkInDateRange != "") ||
        (this.$store.state.participants.filter.cardDateRange != null && this.$store.state.participants.filter.cardDateRange != "") ||
        (this.$store.state.participants.filter.venueMinDate != null && this.$store.state.participants.filter.venueMinDate != "") ||
        (this.$store.state.participants.filter.venueMaxDate != null && this.$store.state.participants.filter.venueMaxDate != "") ||
        (this.$store.state.participants.filter.venueDateRange != null && this.$store.state.participants.filter.venueDateRange != "") ||
        (this.$store.state.participants.filter.venueID != null && this.$store.state.participants.filter.venueID != "") ||
        (this.$store.state.participants.filter.createDateRange != null && this.$store.state.participants.filter.createDateRange != "") ||
        (this.$store.state.participants.filter.createDateMinDate != null && this.$store.state.participants.filter.createDateMinDate != "") ||
        (this.$store.state.participants.filter.createDateMaxDate != null && this.$store.state.participants.filter.createDateMaxDate != "")
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  destroyed() {
    this.showCheckin = false;
    this.showRegDate = true;
    this.resetFilter();
  },

  watch: {
    "$store.state.participants.items": function() {
      this.checkListKey += 1;
    },
    "$store.state.participants.filter.registrationFormId": function() {
      this.$store.state.participants.filter.packetIds = [];
      this.$store.state.participants.filter.additionalServiceIds = [];
      this.$store.state.participants.filter.additionalServiceStatus = null;
      this.$store.state.participants.filter.additionalProductIds = [];
      this.$store.state.participants.filter.additionalProductStatus = null;
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);
      this.checkListKey += 1;
    },
    "$store.state.participants.filter.packetIds": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.additionalServiceIds": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.additionalProductIds": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.additionalProductStatus": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.additionalServiceStatus": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.dayRestriction": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.venueID": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
        this.$store.commit("setParticipantPage", 1);

        this.checkListKey += 1;
      }, 500);
    },
    "$store.state.participants.filter.groupIDs": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.tagIDs": function() {
      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.paymentID": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
        this.$store.commit("setParticipantPage", 1);

        this.checkListKey += 1;
      }, 500);
    },
    "$store.state.participants.filter.couponCode": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");
        this.$store.commit("setParticipantPage", 1);

        this.checkListKey += 1;
      }, 500);
    },
    "$store.state.participants.filter.paymentType": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.paymentStatus": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.automatedMessageId": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.voucherType": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.automatedMessageLogStatus": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.automatedMessageType": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);
      this.checkListKey += 1;
    },
    "$store.state.participants.filter.activationStatus": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.activationCode": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getParticipants");

        this.$store.commit("setParticipantPage", 1);

        this.checkListKey += 1;
      }, 500);
    },
    "$store.state.participants.filter.checkIn": function() {
      if (this.$store.state.participants.filter.checkIn === true) {
        this.showCheckin = true;
        this.showRegDate = false;
      } else {
        this.showCheckin = false;
        this.showRegDate = true;
      }
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;

      this.$store.dispatch("getParticipants");
    },
    "$store.state.participants.filter.isCardPrinted": function() {
      this.$store.dispatch("getParticipants");
      this.$store.commit("setParticipantPage", 1);

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.cardDateRange": function() {
      if (this.$store.state.participants.filter.cardDateRange != null) {
        this.$store.state.participants.filter.minCardPrintDate = this.$store.state.participants.filter.cardDateRange[0];
        this.$store.state.participants.filter.maxCardPrintDate = this.$store.state.participants.filter.cardDateRange[1];
      } else {
        this.$store.state.participants.filter.minCardPrintDate = null;
        this.$store.state.participants.filter.maxCardPrintDate = null;
      }
      this.$store.commit("setParticipantPage", 1);

      this.$store.dispatch("getParticipants");

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.checkInDateRange": function() {
      if (this.$store.state.participants.filter.checkInDateRange != null) {
        this.$store.state.participants.filter.minCheckInDate = this.$store.state.participants.filter.checkInDateRange[0];
        this.$store.state.participants.filter.maxCheckInDate = this.$store.state.participants.filter.checkInDateRange[1];
      } else {
        this.$store.state.participants.filter.minCheckInDate = null;
        this.$store.state.participants.filter.maxCheckInDate = null;
      }
      this.$store.commit("setParticipantPage", 1);

      this.$store.dispatch("getParticipants");

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.createDateRange": function() {
      if (this.$store.state.participants.filter.createDateRange != null) {
        this.$store.state.participants.filter.createDateMinDate = this.$store.state.participants.filter.createDateRange[0];
        this.$store.state.participants.filter.createDateMaxDate = this.$store.state.participants.filter.createDateRange[1];
      } else {
        this.$store.state.participants.filter.createDateMinDate = null;
        this.$store.state.participants.filter.createDateMaxDate = null;
      }
      this.$store.commit("setParticipantPage", 1);

      this.$store.dispatch("getParticipants");

      this.checkListKey += 1;
    },
    "$store.state.participants.filter.venueDateRange": function() {
      if (this.$store.state.participants.filter.venueDateRange != null) {
        this.$store.state.participants.filter.venueMinDate = this.$store.state.participants.filter.venueDateRange[0];
        this.$store.state.participants.filter.venueMaxDate = this.$store.state.participants.filter.venueDateRange[1];
      } else {
        this.$store.state.participants.filter.venueMinDate = null;
        this.$store.state.participants.filter.venueMaxDate = null;
      }
      this.$store.commit("setParticipantPage", 1);

      this.$store.dispatch("getParticipants");

      this.checkListKey += 1;
    },
    "$store.state.participants.selectedRegistrationInputs": function() {
      localStorage.setItem("rInputs" + this.$store.state.event.event.id, JSON.stringify(this.$store.state.participants.selectedRegistrationInputs));

      this.checkListKey += 1;
    },
    checkList() {
      this.checkListKey += 1;
    }
  }
};
</script>

<style lang="less">
.page-content-filter {
  padding: 20px;
  box-shadow: ~"0px 6px 48px -16px rgb(0 0 0 / 22%)";
  background-color: white;
  min-height: 200px;
  border-radius: 16px;
}
.participant-table-header {
  grid-template-columns: 36px 120px 1fr 150px 120px;
}
.participant-table-items {
  .item {
    display: grid;
    margin-bottom: 8px;
    grid-template-columns: 36px 120px 1fr 150px 120px;
    gap: 0.5rem;
    padding: 10px;
    background-color: #f1f1f1;
    align-items: center;
    border-radius: 8px;
    .el-checkbox {
      margin-bottom: 0;
    }
    .participant-header {
      .participant-title {
        font-weight: bold;
      }
      .participant-tag {
        margin-top: 0.5rem;
        font-size: 12px;
        line-height: 12px;
        gap: 0.5rem;
        max-width: max-content;
        .tag-color-pick {
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/Participants.vue